"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSimplifiedPaymentStatus = void 0;
const payment_1 = require("../enums/payment");
const MANUALLY_COLLECTED_METHODS = new Set([
    payment_1.PaymentMethod.Pledge,
    payment_1.PaymentMethod.Invoice,
    payment_1.PaymentMethod.Cash,
    payment_1.PaymentMethod.Cheque,
]);
const getSimplifiedPaymentStatus = (payment, { isStopped, isPastDueDate }) => {
    const isFullyRefunded = payment.transferrableAmount > 0 && payment.refundedAmount === payment.transferrableAmount;
    const isPartiallyRefunded = payment.transferrableAmount > 0 &&
        payment.refundedAmount > 0 &&
        payment.refundedAmount < payment.transferrableAmount;
    const refundSecondaryStatus = isFullyRefunded ? "refunded" : isPartiallyRefunded ? "partiallyRefunded" : undefined;
    if (payment.status === "disputed") {
        return { primaryStatus: "disputed", showStopped: false, secondaryStatus: refundSecondaryStatus };
    }
    if (isFullyRefunded) {
        return { primaryStatus: "refunded", showStopped: false };
    }
    if (isPartiallyRefunded) {
        return { primaryStatus: "partiallyRefunded", showStopped: false };
    }
    switch (payment.status) {
        case "pastDue":
            return { primaryStatus: "pastDue", showStopped: false };
        case "failed":
            return { primaryStatus: "failed", showStopped: false };
        case "succeeded":
            return { primaryStatus: "succeeded", showStopped: isStopped };
        case "processing":
            if (payment.paymentMethod && MANUALLY_COLLECTED_METHODS.has(payment.paymentMethod)) {
                return { primaryStatus: isPastDueDate ? "overdue" : "due", showStopped: isStopped };
            }
            return { primaryStatus: "processing", showStopped: isStopped };
        default:
            return { primaryStatus: payment.status, showStopped: false };
    }
};
exports.getSimplifiedPaymentStatus = getSimplifiedPaymentStatus;
